import { selectors } from 'client/reducers/paymentReducer'
import { shallowEqual, useSelector } from 'react-redux'

export default function usePayment(selector) {
  return useSelector(state => selector(state.payment), shallowEqual)
}

export { selectors }
